export default __webpack_public_path__ + "static/media/48.250c0e2b.png";